import React from 'react';
import {Link} from 'react-router-dom';
import AppSubmenu from './AppSubmenu';


const AppMenu = (props) => {


    return (

        <div className="layout-sidebar" onClick={props.onMenuClick}>

            <Link to="/main" className="logo">
                <img id="logo-img" src="/static/assets/layout/images/ssyzlogo.svg" style={{height: '5em'}}/>

                <h5 className="logo-text" style={{color: '#F5F5F5',fontSize:'1.2rem',marginTop:'-10px'}}>Savunma Sanayii Yapay Zekâ
                    Platformu</h5>
            </Link>

            <div className="layout-menu-container ">


                <AppSubmenu items={props.model} menuMode={props.menuMode} parentMenuItemActive menuActive={props.active}
                            mobileMenuActive={props.mobileMenuActive} root onMenuitemClick={props.onMenuitemClick}
                            onRootMenuitemClick={props.onRootMenuitemClick}/>
            </div>
        </div>
    );
}

export default AppMenu;



// WEBPACK FOOTER //
// ./src/AppMenu.js